import axios from "axios";
import { baseUrl } from "./constants";
const subjectGroupApiUrl = `${baseUrl}/api/CommonMaster/GetSubjectGroupMasters`;

export const fetchSubjectGroupMaster = async () => {
    try {
      const url = subjectGroupApiUrl;
      const response = await axios.get(url);
      if (
        response &&
        response.data &&
        response.data.length > 0
      ) {
        return response.data;
      }
      else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  export const getSchoolId = async () => {    
    try {
        const url = `${baseUrl}/api/Users/GetSchoolId`;
        const response = await axios.get(url);
        
        if (response && response.data !== null && response.data !== undefined) {
            return response.data;  // Assuming the API response returns just the schoolId value.
        } else {
            return null;  // Return null if no schoolId is found.
        }
    } catch (error) {
        console.error("Error fetching data", error);
        return null;  // Return null in case of an error
    }
};

export const getCurrentSession = async () => {    
    try {
        const url = `${baseUrl}/api/SessionMaster/GetCurrentSession`;
        const response = await axios.get(url);
        
        if (response && response.data !== null && response.data !== undefined) {
            return response.data.sessionName;  // Assuming the API response returns just the schoolId value.
        } else {
            return null;  // Return null if no schoolId is found.
        }
    } catch (error) {
        console.error("Error fetching data", error);
        return null;  // Return null in case of an error
    }
};